import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';
import { useTranslation } from 'react-i18next';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { ImpactReportDetail, ImpactReportDetailHeader } from '@/impactReports/ImpactReportDetail.page';
import { useImpactReportCategories } from '@/impactReports/impactReports.store';
import { hasAnalyticsAdminCapability } from '@/services/authorization.service';
import { Modal } from '@seeqdev/qomponents';
import type { ImpactReportUseCase } from '@/impactReports/impactReport.types';

interface ImpactReportDetailModalProps {
  closeFn: () => void;
  details: ImpactReportUseCase;
  editCallbackFn?: () => void;
}

export const ImpactReportDetailModal = ({ closeFn, details, editCallbackFn }: ImpactReportDetailModalProps) => {
  const currentUser = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.currentUser);

  const { t } = useTranslation();
  const categories = useImpactReportCategories();

  // Edit and Delete is only shown for the owner of the impact or users with analytics-admin capability.
  const getOnEditFunction = () => {
    if (
      details &&
      editCallbackFn &&
      (hasAnalyticsAdminCapability() || details[SeeqNames.ImpactReport.ImpactOwner] === currentUser.id)
    ) {
      return editCallbackFn;
    }
    return null;
  };

  return (
    <Modal
      title={t('IMPACT_REPORT.DETAIL')}
      size="4xl"
      submitButtonLabel={t('EDIT')}
      cancelButtonLabel={t('CLOSE')}
      hideFooterButtons={true}
      open={true}
      onSubmit={editCallbackFn ? () => editCallbackFn() : undefined}
      onClose={closeFn}
      customHeader={<ImpactReportDetailHeader {...details} />}>
      <ImpactReportDetail
        {...details}
        categories={categories}
        onClose={closeFn}
        onEdit={getOnEditFunction() ?? undefined}
      />
    </Modal>
  );
};
